import React from 'react';
import DisplayConfiguration from './DisplayConfiguration';
import { pickDataAttributes } from '../../../Util';

const styles = Object.freeze([
  {
    margin: '0 auto',
    maxWidth: '1128px',
    width: '100%'
  }
]);

const DisplayMaxWidthWide = (props) => {
  const dataAttributes = pickDataAttributes(props, 'display-max-width-wide');
  
  return <DisplayConfiguration {...props} styles={styles} {...dataAttributes} />;
}
export default DisplayMaxWidthWide;